import { useEffect, useState } from 'react';

/**
 * Returns the latest `value` only after `delayMs` has passed since the last
 * change. Common debounce pattern for inputs that drive expensive queries
 * (search, auto-save, server validation).
 *
 * @example
 *   const debounced = useDebounce(searchInput, 400);
 *   useEffect(() => triggerSearch(debounced), [debounced]);
 */
export function useDebounce<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const handle = window.setTimeout(() => setDebounced(value), delayMs);
    return () => window.clearTimeout(handle);
  }, [value, delayMs]);

  return debounced;
}
